import { useVoiceSettings } from "../VoiceSettings/useVoiceSettings";
import ClarificationResponses from "./ClarificationResponses";
import HelloResponses from "./HelloResponses";
import NeutralFillers from "./NeutralFillers";

export default function VoiceCache(props) {
  const { voiceCache, workspaceId, assistantId, syncAssistant, locked } = props;
  const { updateVoiceSettings } = useVoiceSettings({
    syncAssistant,
    workspaceId,
    assistantId,
  });

  const handleSave = (data) => {
    const payload = {
      voiceCache: {
        ...voiceCache,
        ...data,
      },
    };
    updateVoiceSettings(payload);
  };

  return (
    <div className="flex flex-col gap-y-8 m-4">
      <NeutralFillers
        voiceCache={voiceCache}
        onSave={handleSave}
        locked={locked}
      />
      <HelloResponses
        voiceCache={voiceCache}
        onSave={handleSave}
        locked={locked}
      />
      <ClarificationResponses
        voiceCache={voiceCache}
        onSave={handleSave}
        locked={locked}
      />
    </div>
  );
}
